// features
export const FEATURE_AVAILABILITY   = 'availability';
export const FEATURE_RATINGS        = 'ratings';
export const FEATURE_CONNECTIONS    = 'connections';
export const FEATURE_MESSAGING      = 'messaging';
export const FEATURE_MARKETPLACE_BOOKINGS = 'bookings';
export const FEATURE_PRODUCT_ALIASES = 'product_aliases';
export const FEATURE_PROMOTION_POSTS_AI = 'promotion_posts_ai';

// mutation types
export const SET_ENABLED_FEATURES = 'setEnabledFeatures';

const state = {
  enabledFeatures: [],
};

const getters = {
  // Method-Style Access
  isFeatureEnabled: (_state) => (featureKey) => {
    if (typeof _state.enabledFeatures !== 'undefined'
      && typeof _state.enabledFeatures[featureKey] !== 'undefined') {
      return _state.enabledFeatures[featureKey];
    }
    return false;
  },
};

const actions = {

};

const mutations = {
  [SET_ENABLED_FEATURES](_state, enabledFeatures) {
    if (enabledFeatures) {
      // eslint-disable-next-line no-param-reassign
      _state.enabledFeatures = enabledFeatures;
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
